import { ApiClientBase } from "./ApiClientBase";

class DPAInstanceService extends ApiClientBase {
    constructor() {
        super("odata/v4/DPAInstance/");
    }

    public Confirm(id: number) {
        return this.post(`${id}/Confirm`);
    }
}

export const dpaInstanceService = new DPAInstanceService();